function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M839.3 1.44301C838.91 0.274878 837.353 -0.698565 836.185 0.664251C835.211 1.63769 834.432 3.38988 835.795 4.36332C836.769 5.14208 837.742 5.14208 838.91 5.14208C841.247 5.33677 841.441 2.02707 839.3 1.44301Z",
  fill: "#333333"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1086.75 24.8056C1084.22 24.8056 1084.22 28.6993 1086.75 28.6993C1089.28 28.6993 1089.28 24.8056 1086.75 24.8056Z",
  fill: "#333333"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1031.07 258.431C1028.54 258.431 1028.54 262.325 1031.07 262.325C1033.6 262.325 1033.6 258.431 1031.07 258.431Z",
  fill: "#333333"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1151.77 344.094C1150.8 344.094 1150.02 344.094 1149.24 343.315C1147.49 341.563 1144.57 344.288 1146.52 346.041C1148.07 347.403 1149.83 347.988 1151.77 347.988C1154.3 347.988 1154.3 344.094 1151.77 344.094Z",
  fill: "#333333"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.703 188.343H383.341C380.81 188.343 380.81 192.237 383.341 192.237H384.703C387.234 192.237 387.234 188.343 384.703 188.343Z",
  fill: "#333333"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M497.622 59.8494H496.26C493.729 59.8494 493.729 63.7431 496.26 63.7431H497.622C500.153 63.7431 500.153 59.8494 497.622 59.8494Z",
  fill: "#333333"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M527.41 221.44C526.631 222.219 526.631 223.387 527.41 224.166C527.994 224.75 528.578 224.75 529.162 224.555C529.162 224.555 529.162 224.555 529.162 224.75C529.162 224.75 529.162 224.75 529.162 224.945C529.162 225.139 529.162 225.139 529.162 225.334C529.356 227.865 533.25 227.865 533.056 225.334C533.056 222.414 530.33 218.715 527.41 221.44Z",
  fill: "#333333"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M163.927 24.0268C162.954 25.1949 162.175 26.5577 161.98 27.9206C161.98 30.4515 165.874 30.4515 165.874 27.9206C165.874 27.9206 165.874 27.9206 165.874 27.7259C165.874 27.3365 166.263 26.9471 166.458 26.7524C168.405 25.0002 165.679 22.2746 163.927 24.0268Z",
  fill: "#333333"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.28313 184.45C2.92031 184.45 1.36282 184.839 0.584064 185.812C-0.194688 186.591 -0.194688 187.954 0.584064 188.733C1.16813 189.317 2.14157 189.512 3.11501 189.512C4.08844 189.512 4.6725 188.927 4.86719 188.149C6.81407 187.565 6.61939 184.45 4.28313 184.45Z",
  fill: "#333333"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M165.29 193.6C163.343 193.6 162.175 194.963 161.98 196.91C161.98 197.883 162.954 198.857 163.927 198.857C164.901 198.857 165.485 198.272 165.679 197.494C167.821 196.715 167.626 193.405 165.29 193.6Z",
  fill: "#333333"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.5751 353.244C13.8229 353.828 11.6813 354.607 11.0973 356.554C10.5132 358.501 12.2654 359.863 13.8229 360.642C15.9645 361.81 18.106 358.501 15.7698 357.333C15.9645 357.138 16.3538 357.138 16.5485 356.943C18.8848 356.164 17.9114 352.465 15.5751 353.244Z",
  fill: "#333333"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M138.034 433.65C135.503 433.65 135.503 437.544 138.034 437.544C140.565 437.544 140.565 433.65 138.034 433.65Z",
  fill: "#333333"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M66.5834 602.445C64.2471 602.445 62.3002 603.029 62.1055 605.754C62.1055 606.728 63.079 607.701 64.0524 607.701C64.8312 607.701 65.6099 607.117 65.8046 606.338C65.9993 606.338 66.3887 606.338 66.5834 606.338C69.1143 606.338 69.1143 602.445 66.5834 602.445Z",
  fill: "#333333"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M439.216 443.969C439.021 443.969 438.632 443.579 438.632 443.385C438.632 442.411 437.853 441.438 436.685 441.438C435.712 441.438 434.738 442.411 434.738 443.385C434.933 445.916 436.88 447.862 439.216 447.862C440.189 447.862 441.163 446.889 441.163 445.916C441.163 444.942 440.189 444.163 439.216 443.969Z",
  fill: "#333333"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M502.684 392.182C500.153 392.182 500.153 396.075 502.684 396.075C505.215 396.075 505.215 392.182 502.684 392.182Z",
  fill: "#333333"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M444.278 623.082H437.853C435.322 623.082 435.322 626.975 437.853 626.975H444.278C446.809 626.975 446.809 623.082 444.278 623.082Z",
  fill: "#333333"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M498.79 579.082C496.26 579.082 496.26 582.976 498.79 582.976C501.321 582.976 501.321 579.082 498.79 579.082Z",
  fill: "#333333"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M732.611 631.453L730.858 629.701C729.106 627.949 726.381 630.674 728.133 632.427L729.885 634.179C731.637 636.126 734.363 633.205 732.611 631.453Z",
  fill: "#333333"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M758.504 564.675H755.973C753.442 564.675 753.442 568.569 755.973 568.569H758.504C761.035 568.569 761.035 564.675 758.504 564.675Z",
  fill: "#333333"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M829.76 579.082H828.397C825.866 579.082 825.866 582.976 828.397 582.976H829.76C832.291 582.976 832.291 579.082 829.76 579.082Z",
  fill: "#333333"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1078.96 632.232C1077.99 632.232 1077.21 632.232 1076.43 631.453C1074.68 629.701 1071.76 632.427 1073.7 634.179C1075.26 635.542 1077.01 636.126 1078.96 636.126C1081.49 636.126 1081.49 632.232 1078.96 632.232Z",
  fill: "#333333"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1188.96 593.878C1188.38 592.516 1186.82 592.126 1185.45 591.931C1183.12 591.737 1182.92 595.047 1184.87 595.631C1185.07 596.409 1185.84 597.188 1186.62 596.993C1188.57 596.993 1189.74 595.631 1188.96 593.878Z",
  fill: "#333333"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1028.34 493.419H1026.59C1024.06 493.419 1024.06 497.313 1026.59 497.313H1028.34C1030.87 497.313 1030.87 493.419 1028.34 493.419Z",
  fill: "#333333"
});

var SvgBackgroundParticles = function SvgBackgroundParticles(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 1190,
    height: 636,
    viewBox: "0 0 1190 636",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBackgroundParticles, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/background_particles.d70ab44b.svg";
export { ForwardRef as ReactComponent };